module.exports = __webpack_public_path__ + "static/media/qq_qun.c7b33903.jpg";